import React, { Component } from 'react';
import { connect } from 'react-redux';
import { CardBody, Card, Label, Col, Button, Row } from "reactstrap";
import { Preloading } from '../../components/UI/Preloader/action';
import fileSaver from 'file-saver';
import { toast } from 'react-toastify';
import {downloadPartnerCostExcelRequest, partnerCostUpload, partnerCostTemplateDownloadRequest} from "./action"

class PartnerCostUpload extends Component {
    constructor(props) {
        super(props);
        this.state = {
          partnerCostExcelFile: ''
        };
    }


    componentDidUpdate(prevProps) {
       if (this.props.downloadPartnerCostExcelTemplateSuccess !== prevProps.downloadPartnerCostExcelTemplateSuccess) {
            this.props.preloading(false)
            var blob = new Blob([this.props.downloadPartnerCostExcelTemplateSuccess.data], { type: 'application/octet-stream' });
            fileSaver.saveAs(blob, `partnerCostExcelTemplateFile.xlsx`);
            this.displaySuccessMessage("Cost Excel Template Downloded Successfully")
        }

        if (this.props.downloadPartnerCostExcelTemplateFail !== prevProps.downloadPartnerCostExcelTemplateFail) {
          this.props.preloading(false)
          this.displayErrorMessage("Cost Excel Template Downlode failed")
        }

        if (this.props.downloadPartnerCostExcelSuccess !== prevProps.downloadPartnerCostExcelSuccess) {
          this.props.preloading(false)
          var blob = new Blob([this.props.downloadPartnerCostExcelSuccess.data], { type: 'application/octet-stream' });
          fileSaver.saveAs(blob, `partnerCost.xlsx`);
          this.displaySuccessMessage("Partner Cost Excel Downloded Successfully")
      }

      if (this.props.partnerCostUploadSuccessMsg !== prevProps.partnerCostUploadSuccessMsg) {
        this.props.preloading(false)
        this.displaySuccessMessage("Partner Cost Excel Uploaded Successfully.")
        this.handleResetExcel();
        setTimeout(() => {
          window.location.reload();
      }, 1500);
      }      

      if (this.props.partnerCostUploadFail !== prevProps.partnerCostUploadFail) {
       this.props.preloading(false)
      var blob = new Blob([this.props.partnerCostUploadFail.data], { type: 'application/octet-stream' });
      fileSaver.saveAs(blob, `partnerCostError.xlsx`);
      this.displayErrorMessage("Partner Cost Excel Upload Failed..")
      this.handleResetExcel();
     } 

    }


    displayErrorMessage = (message) => {
      toast.error(
          <div>
              <i className="fa fa-exclamation-triangle"></i>&nbsp; {message}
          </div>
      )
  }

  displaySuccessMessage = (message) => {
    toast.success(
        <div>
            <i className="fa fa-exclamation-triangle"></i>&nbsp; {message}
        </div>
    )
}


    handleTemplateDownload = () => {
        this.props.preloading(true)
        this.props.partnerCostTemplateDownloadRequest();
    }
    
    handleDownloadPartnerCostExcel = () => {
        this.props.preloading(true)
        this.props.downloadPartnerCostExcelRequest();
    }

  handleUploadExcel = (event) => {
    this.setState({
      partnerCostExcelFile: event.target.files[0]
    })
    event.preventDefault();
    event.target.value = null;
  }

  handleResetExcel = () => {
    this.setState({
      partnerCostExcelFile:''
    })
  }


 handleSubmit = () => {
  if (!this.state.partnerCostExcelFile) {
    this.displayErrorMessage('*Please select the file to upload. ')
  }
  else{
    this.props.partnerCostUpload({ file: this.state.partnerCostExcelFile});
    this.props.preloading(true)
  }
}


    render() {
        return (
          <Col>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h4 className="mb-0 text-center">Partner Cost Upload</h4>
            </div>
            <Card>
              <CardBody>
                <Label>Partner Cost Upload Template</Label>
                <Row>
                  <Col sm="22">
                    <Button
                      color="primary"
                      onClick={this.handleTemplateDownload}
                      className="btn color-excel-download "
                    >
                      <i className="fa fa-file-excel-o fa-lg"></i>
                      &nbsp;&nbsp;Download Template
                    </Button>
                    <Row
                      color="primary"
                      className="btn btn-primary ml-0 position-relative excel-upload-btn browse-files ml-3"
                      title="Upload Request Template"
                    >
                      <input
                        onChange={this.handleUploadExcel}
                        type="file"
                        name="file"
                        id="file"
                        className="upload-file"
                        title="Upload Request Template"
                        accept=".xlsx"
                      />
                      <i className="fa fa-paperclip color-888 rotate-90deg p-1 fa-lg" />{" "}
                      Upload Template
                    </Row>

                    <Button
                      className="ml-5"
                      color="primary"
                      onClick={this.handleSubmit}
                    >
                      Submit
                    </Button>
                    <Button className="ml-5" color="success" onClick={this.handleDownloadPartnerCostExcel}>Download Existing Data</Button>
                    <Row className={(this.state.partnerCostExcelFile) ? "text-muted ml-1 transaction-file-name-text" : "text-danger ml-1 noUploadWarning-text"}>{(this.state.partnerCostExcelFile) ? this.state.partnerCostExcelFile.name : ""}</Row>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </Col>
        );
    }     
}

const mapStateToProps = (state, ownProps) => ({
  partnerCostUploadSuccessMsg: state.partnerCostReducer.partnerCostUploadSuccessMsg,
  partnerCostUploadFail: state.partnerCostReducer.partnerCostUploadFail,
  downloadPartnerCostExcelSuccess:state.partnerCostReducer.downloadPartnerCostExcelSuccess,
  downloadPartnerCostExcelFail:state.partnerCostReducer.downloadPartnerCostExcelFail,
  downloadPartnerCostExcelTemplateSuccess:state.partnerCostReducer.downloadPartnerCostExcelTemplateSuccess,
  downloadPartnerCostExcelTemplateFail:state.partnerCostReducer.downloadPartnerCostExcelTemplateFail,
})

const mapDispatchToProps = (dispatch, ownProps) => ({
  preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); },
  partnerCostTemplateDownloadRequest: () => dispatch(partnerCostTemplateDownloadRequest()),
  downloadPartnerCostExcelRequest: () => dispatch(downloadPartnerCostExcelRequest()),
  partnerCostUpload: (data) => dispatch(partnerCostUpload(data)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PartnerCostUpload);
